module.exports = __webpack_public_path__ + "static/media/guide_1.68ce2e75.svg";